// src/hooks/useAuctionSocket.ts
import { useCallback, useEffect } from 'react';
import { connectSocket, SOCKET_EVENTS } from '../utilities/socket';

const useAuctionBroadcastWsHook = (token?: string | null, callback?: any) => {
  const doCallback = useCallback(() => {
    if (typeof callback === 'function') {
      callback();
    }
  }, [callback]);

  useEffect(() => {
    if (!token)
      return () => {
        // no cleanup needed
      };

    // init socket with token
    const socket = connectSocket(token);

    if (!socket) {
      // console.warn('Socket socket not initialized');
      return () => {
        // no cleanup needed
      };
    }

    // join room
    socket.emit(SOCKET_EVENTS.JOIN_BROADCAST_AUCTION);

    // attach listener
    socket.on(SOCKET_EVENTS.AUCTION_BID_PLACE, doCallback);

    // Socket.io uses 'connect' event when connection established or re-established
    socket.on('connect', () => {
      // re-join to ensure we're in the room after a reconnect
      socket.emit(SOCKET_EVENTS.JOIN_BROADCAST_AUCTION);
      // refetch snapshot to reconcile missed messages
      // doCallback();
    });

    // cleanup
    return (): void => {
      try {
        socket.emit(SOCKET_EVENTS.LEAVE_BROADCAST_AUCTION);
        socket.off(SOCKET_EVENTS.AUCTION_BID_PLACE, doCallback);
        socket.off('connect'); // remove on connect handler above
      } catch (err) {
        // ignore
      }
    };
  }, [token, doCallback]);
};

export default useAuctionBroadcastWsHook;
